var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"description"},[_vm._v(" Я подтверждаю, что мне исполнилось 18 лет, и я ознакомился(-лась) с "),_c('router-link',{attrs:{"to":"/sogl"}},[_vm._v("условиями предоставления услуг")]),_vm._v(". ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }